import { DateAndGuestCountFilterPill } from '@shared/availability/DateAndGuestCountFilterPill';
import { useIsOpen } from '@shared/hooks/useIsOpen';
import { toISODateFormat } from '@shared/utils/dateFormatters';
import { useAvailabilityContext } from 'webReservations/context/AvailabilityContext';
import { useRestaurantContext } from 'webReservations/context/RestaurantContext';
import { DateAndGuestCountFilterPopover } from 'webReservations/filters/DateAndGuestCountFilterPopover';
import styles from './AvailabilityFilters.scss';
import { sendGa4AvailabilityFilterDateGuestStartEvent } from './gaHelpers';

export const AvailabilityFilters = () => {
  const { close, isOpen, open } = useIsOpen();
  const { restaurantDetails } = useRestaurantContext();
  const { selectedGuestCount, selectedDate } = useAvailabilityContext();

  const sendGaFilterEvent = () => {
    sendGa4AvailabilityFilterDateGuestStartEvent({
      date: toISODateFormat(selectedDate),
      guestCount: selectedGuestCount,
      restaurantName: restaurantDetails.name,
    });
  };

  return (
    <>
      {isOpen && <div className={styles.curtain} />}
      <div className={styles.container}>
        <DateAndGuestCountFilterPill
          closeFilter={close}
          isOpenFilter={isOpen}
          onFilterOpen={sendGaFilterEvent}
          openFilter={open}
          selectedDate={selectedDate}
          selectedGuestCount={selectedGuestCount}
          popover={<DateAndGuestCountFilterPopover />}
        />
      </div>
    </>
  );
};
